const group = {
  0: {
    name: 'Add Tour',
    authRule: 'addTour'
  },
  1: {
    name: 'Add Assignment',
    authRule: 'addAssignment'
  },
  2: {
    name: 'Notification Log',
    authRule: ''
  },
  3: {
    name: 'Change Day Type',
    authRule: 'changeDayType'
  },
  4: {
    name: 'Add Day Off Request',
    authRule: 'addDayTypeRequest'
  }
};

export default group;



// WEBPACK FOOTER //
// ./src/Components/Schedule/utils/live-schedules/context-menu-arrays/group.js